import * as dateish from "js/dateish";
import * as d3 from "d3";

import type { Taxon } from "./taxonomy";
import type { Checklist } from "./checklists";
import type { Location } from "./locations";
import { locCountryCode } from "./locations";
import type { Region, Country, State, County, } from "./regions";

export interface Observation {
  checklist: Checklist // TODO: ChecklistID or flatten?
  location: Location // TODO: LocationID or flatten?
  taxon: Taxon // TODO: TaxonID or flatten?
  count?: number
  // breedingCode: r[19],
  details: string
  date: { year: number, month: dateish.MoY, day: dateish.DoM, when: Date }, // TODO: Real date
}

export function obsToCountries(all: Observation[]): Country[] {
  return Array.from(new Set(all.map(obCountryCode)).values()).map(code => {
    return { code, kind: 'country', name: 'todo: lookup' };
  });
}
export function obsToStates(all: Observation[]): State[] {
  return Array.from(new Set(all.map(o => o.location.state)).values()).map(code => {
    return { code, kind: 'state', name: 'todo: lookup' };
  });
}
export function obsToCounties(all: Observation[]): County[] {
  throw new Error('todo');
}
export function obsToLocations(all: Observation[]): Location[] {
  return Array.from(d3.rollup(all, obs => obs[0].location, o => o.location.id).values());
}

export function obsByCountry(all: Observation[]): [Country, Observation[]][] {
  const fn = (obs: Observation[]): [Country, Observation[]] => [ obCountry(obs[0]), obs ];
  return Array.from(d3.rollup(all, fn, o => o.location.id).values());
}
export function obsByState(all: Observation[]): [State, Observation[]][] {
  const fn = (obs: Observation[]): [State, Observation[]] => [ obState(obs[0]), obs ];
  return Array.from(d3.rollup(all, fn, o => o.location.id).values());
}
export function obsByCounty(all: Observation[]): [County, Observation[]][] {
  const fn = (obs: Observation[]): [County, Observation[]] => [ obCounty(obs[0]), obs ];
  return Array.from(d3.rollup(all, fn, o => o.location.id).values());
}
export function obsByLocation(all: Observation[]): [Location, Observation[]][] {
  const fn = (obs: Observation[]): [Location, Observation[]] => [ obs[0].location, obs ];
  return Array.from(d3.rollup(all, fn, o => o.location.id).values());}

export function obsFilterRegions(all: Observation[], regions: Region[]): Observation[] {
  if (regions.length === 0) {
    return all.slice();
  }

  return all.filter(o => {
    const { state, county } = o.location;
    return regions.some(r => {
      switch (r.kind) {
        case "country": return state.startsWith(r.code);
        case "state": return state === r.code;
        case "county":  return county === r.name;
      }
    });
  });
}

export function obCountry(o: Observation): Country {
  return { code: obCountryCode(o), name: 'TODO', kind: 'country' };
}
export function obState(o: Observation): State {
  return { code: o.location.state, name: 'TODO', kind: 'state' };
}
export function obCounty(o: Observation): County {
  return { code: 'TODO', name: o.location.county, kind: 'county' };
}

export function obCountryCode(o: Observation): string {
  return locCountryCode(o.location);
}
